import { Component, OnInit,Inject } from '@angular/core';
import { CustomerService } from '../../GET_NEW_UI/services/customer.service';
import {  Customer_ContactVM,  UserOverviewModelCustomerContact } from '../Models/customer-contact.model';
import { CustomerContactService } from './customer-contact.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CryptoService } from '../../../services/crypto.service';


@Component({
  selector: 'app-add-new-user-cl',
  templateUrl: './add-new-user-cl.component.html',
  styleUrls: ['./add-new-user-cl.component.css']
})
export class AddNewUserClComponent implements OnInit {

  // myControl = new FormControl();
  // filteredOptions: Observable<UserInfoVMJS[]>;
  array1:any = [];
  array2:any = [];
  
  selectedOptions1:any = [];
  selectedOptions2:any = [];
  
  userid:number
  usename:string
  selectedTab:number
  UserList:UserOverviewModelCustomerContact[];
  CopymodelList:UserOverviewModelCustomerContact[]
  selectedUserId:number;
  customerId:number=0;
  customerName
  contactLsit:any;
  jobsiteList:UserOverviewModelCustomerContact[]=[]
  customerList:UserOverviewModelCustomerContact[]=[]
  filteredJobsiteforDropdown:UserOverviewModelCustomerContact[]=[]
  filteredCustomerforDropdown:UserOverviewModelCustomerContact[]=[]

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    private  _dialog:MatDialog,
    public dialogRef:MatDialogRef<AddNewUserClComponent>,
    private _contactService:CustomerContactService,
    private _customerService:CustomerService,
    private crypto: CryptoService
  ) { }

  ngOnInit() {
    //console.log("data",this.data)
    this.userid=this.data.userid
    this.usename=this.data.usename
    this.selectedTab=this.data.selectedTab
   
    this.customerId=this.data.customerId;
    this.customerName=this.data.customerName
    console.log("customerId dialodngoninit", this.customerId)
  //  this.GetuserDetails();
    //this.PostUserContact();
    this.GetAllUsersForUser()
  }

  //GetAllUsersForUser

  GetAllUsersForUser(){
    if(this.customerId>0){
      this._contactService.GetAllUsersForUser().subscribe(res=>{
        //console.log("administration user accessd", res)
       //this.jobsiteList= res.filter(x=>x.Access=="Jobsite")
       this.customerList=res.filter(x=>x.Access=="Customer")
   
       // console.log(" this.jobsiteList",  this.jobsiteList)
      //  console.log(" this.customerList",  this.customerList)
       // console.log(" this.customerName",  this.customerName)
        let arr_ = [];
     this.customerList.map(x=>{
       if(x.TeamName.length>0 && x.TeamName!=null){
        
         x.TeamName.map(y=>{
          if( y == this.customerName){
            arr_.push(x)
          }
         })
         
       }
     })
     this.filteredCustomerforDropdown=arr_;
      //  this.filteredJobsiteforDropdown= this.jobsiteList.filter(x=>x.TeamName==)
       
       
       // console.log(" this.filteredCustomerforDropdown",  this.filteredCustomerforDropdown)
        this.UserList = this.filteredCustomerforDropdown;
        this.UserList.forEach(x => {
          x.FullName = this.crypto.decrypt(x.FullName);
        });
        //console.log("UserList,", this.UserList);
        this.CopymodelList = this.filteredCustomerforDropdown;
        this.CopymodelList.forEach(x => {
          x.FullName = this.crypto.decrypt(x.FullName);
        });
      
      })
    }
    
  }

  // GetuserDetails(){
  //   if(this.customerId>0){
  //     this._customerService.GetuserDetails_(this.customerId).subscribe(res=>{
  //       console.log("customerId dialod", this.customerId)
  //       this.UserList = res;
  //       this.CopymodelList =res;
  //       console.log("this.userlist",this.UserList);
      
  //     })
  //   }
    
  // }
  model_auto_:number
  modelselect(modelid) {
    console.log("this.modelTitle", modelid,this.UserList)

   // this.model_auto_ =this.UserList.find(f=>f.FullName == modelid).UserId;
    this.model_auto_ =   modelid
    
    
    //console.log("model_auto_", this.model_auto_, this.selectedUserId)
   
  }

  DialogClose(){
    this.dialogRef.close(false)

  }

  AddNewUser(){
    ///console.log("addUserContact", this.selectedUserId)
    let params = new  Customer_ContactVM();
    params.customer_auto=Number(this.customerId);
    params.user_auto=this.model_auto_;
    params.equipmentid_auto=0;
    params.EvalA=true;
    params.EvalB=true;
    params.EvalC=true;
    params.EvalX=true;
    params.eq_undercarriage=true;
    params.Type='CUST';
    


    this._customerService.AddNewUser_(params).subscribe(res=>{
     // console.log("result",res);
      if(res==true)
      {
        this.DialogClose();
      }
    })
   // console.log("this.selectedUserId",this.selectedUserId);
   // console.log("this.customer ID",this.customerId);

    
  }
 
  /*
  GetContactbyId(){
    this._contactService.GetContactbyId(this.customerId).subscribe(res=>{
      this.contactLsit = res;
    })
  }*/



  changeModelAutoComplete(event){
    const filterValue = event.target.value.toLowerCase();
 
    this.UserList = this.CopymodelList.filter(option => option.FullName.toLowerCase().includes(filterValue));
  }

  
  getTitle(UserId: number) {
    return this.UserList.find(u => u.UserId === UserId).FullName;
  }
}
